module.exports = __webpack_public_path__ + "img/IMG_1444.56026258.jpg";